import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchTaskBucketTableAndFilterSchema } from "model/TaskBucketModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const TaskBucketContext = createContext();

export const TaskBucketProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [taskBucketContextData, setTaskBucketContextData] = useState();

  const fetchTaskBucketContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:taskBucket", () =>
        fetchTaskBucketTableAndFilterSchema([])
      );
      if (response?.success) {
        setTaskBucketContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch task bucket metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TaskBucketContext.Provider
      value={{
        fetchTaskBucketContextData,
        taskBucketContextData,
        loading,
        error,
      }}
    >
      {children}
    </TaskBucketContext.Provider>
  );
};

export const useTaskBucketContext = () => useContext(TaskBucketContext);
